import { MiBox, MiIcon, MiList, MiModalConfirm } from "@miplatform/components";
import { BUTTON_LABELS, ICONS_WEB, PAGINATION } from "@miplatform/constants";
import * as mdi from "@mdi/js";
import { useTheme } from "@mui/material";
import { Box } from "@mui/system";
import { InspectionTemplateAssignmentTemplateModal } from "../InspectionTemplateAssignmentTemplateModal";
import { useAssignmentTemplatesTabViewModel } from "./useAssignmentTemplatesTabViewModel";

export function AssignmentTemplatesTab({ inspectionTemplate, refresh }) {
  const {
    selectedAssignmentTemplate,
    isDeleteModalOpen,
    deleteAssignmentTemplate,
    openDeleteModal,
    closeDeleteModal,
    closeEditModal,
    openEditModal,
    isEditModalVisible,
    handleUpdateOrderTemplateAssignmentTemplate,
  } = useAssignmentTemplatesTabViewModel({
    inspectionTemplateId: inspectionTemplate.id,
    refresh,
  });

  const theme = useTheme();

  const renderIcon = (value) => {
    return (
      <Box display="flex" justifyContent="center" alignItems="center">
        {value ? (
          <MiIcon
            color={theme.palette.success.main}
            path={mdi[ICONS_WEB.CHECK_CIRCLE]}
            sx={{ color: "success.main" }}
          />
        ) : (
          <MiIcon
            color={theme.palette.error.main}
            path={mdi[ICONS_WEB.CLOSE_CIRCLE]}
          />
        )}
      </Box>
    );
  };

  const columns = [
    {
      field: "name",
      headerName: "Name",
      headerAlign: "left",
      align: "left",
      groupable: false,
      flex: 1,
    },
    {
      field: "shortName",
      headerName: "Short Name",
      groupable: false,
      headerAlign: "left",
      align: "left",
      flex: 1,
    },
    {
      field: "scheduleOffsetReference",
      headerName: "Schedule Offset Reference",
      groupable: false,
      headerAlign: "left",
      align: "left",
      flex: 1,
    },
    {
      field: "scheduleOffsetDays",
      headerName: "Schedule Offset Days",
      groupable: false,
      headerAlign: "left",
      align: "left",
      flex: 1,
    },
    {
      field: "triggersInProgressOrderStatus",
      headerName: "Trigger InProgress Order Status",
      groupable: false,
      headerAlign: "left",
      align: "left",
      flex: 1,
      renderCell: ({ row }) => {
        return renderIcon(row.triggersInProgressOrderStatus);
      },
    },
    {
      field: "triggersCompleteOrderStatus",
      headerName: "Trigger Complete Order Status",
      groupable: false,
      headerAlign: "left",
      align: "left",
      flex: 1,
      renderCell: ({ row }) => {
        return renderIcon(row.triggersCompleteOrderStatus);
      },
    },
  ];

  const getRowActions = (row) => [
    {
      text: BUTTON_LABELS.EDIT,
      onClick: () => {
        openEditModal(row);
      },
      renderIcon: () => (
        <MiIcon
          path={mdi[ICONS_WEB.PENCIL_OUTLINE]}
          size={1}
          color={theme.palette.green.main}
        />
      ),
    },
    {
      text: BUTTON_LABELS.DELETE,
      onClick: () => {
        openDeleteModal({ ...row, modifiedOn: inspectionTemplate.modifiedOn });
      },
      renderIcon: () => (
        <MiIcon
          path={mdi[ICONS_WEB.TRASH_CAN]}
          color={theme.palette.red.main}
        />
      ),
      disabled: row.required,
    },
  ];

  return (
    <MiBox>
      <MiList
        columns={columns}
        data-testid="template-table"
        data={inspectionTemplate.assignmentTemplates || []}
        paginationMode={PAGINATION.CLIENT}
        getRowActions={getRowActions}
        initialState={{
          sorting: {
            sortModel: [{ field: "name", sort: "asc" }],
          },
        }}
      />
      <MiModalConfirm
        title="Confirm Delete"
        description={`Are you sure you want to delete: ${selectedAssignmentTemplate?.name}?`}
        open={isDeleteModalOpen}
        handlePositive={deleteAssignmentTemplate}
        textPositive={BUTTON_LABELS.DELETE}
        handleNegative={closeDeleteModal}
      />
      <InspectionTemplateAssignmentTemplateModal
        item={selectedAssignmentTemplate}
        open={isEditModalVisible}
        title="Edit Assignment Template"
        buttonTitle="Update"
        onClose={closeEditModal}
        onSubmit={handleUpdateOrderTemplateAssignmentTemplate}
      />
    </MiBox>
  );
}
